import {addCircularTabFocus, focusElement, hookToAttributeSelector} from '@wix/panda-js-utils'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {StyledButton} from '../../styled-button'
import {classes} from '../error-modal.st.css'
import {SeatsUnavailableProps} from './interfaces'

export const SeatsUnavailable = ({close}: SeatsUnavailableProps) => {
  const {t} = useTranslation()
  const {isMobile} = useEnvironment()

  React.useEffect(() => {
    focusElement({selector: hookToAttributeSelector(DH.MODAL_TITLE)})
    addCircularTabFocus(
      hookToAttributeSelector(DH.SEATS_UNAVAILABLE_BUTTON),
      hookToAttributeSelector(DH.SEATS_UNAVAILABLE_BUTTON),
    )
  }, [])

  return (
    <div className={classes.container} data-hook={DH.SEATS_UNAVAILABLE_MODAL}>
      <div className={classNames(classes.content, {[classes.desktopContent]: !isMobile})}>
        <div className={classes.text}>
          <Text
            data-hook={DH.MODAL_TITLE}
            tagName="h2"
            className={classNames(classes.title, {[classes.mobileTitle]: isMobile})}
          >
            {t('seatings_seatsUnavailableModal_title')}
          </Text>
          <Text tagName="p" className={classes.subtitle}>
            {t('seatings_seatsUnavailableModal_subtitle')}
          </Text>
        </div>
        <StyledButton onClick={() => close()} fullWidth={false} dataHook={DH.SEATS_UNAVAILABLE_BUTTON}>
          {t('seatings_seatsUnavailableModal_button')}
        </StyledButton>
      </div>
    </div>
  )
}
